import { render, staticRenderFns } from "./FinanceReportsPeopleAndProjects.vue?vue&type=template&id=6464795b&scoped=true"
import script from "./FinanceReportsPeopleAndProjects.vue?vue&type=script&lang=js"
export * from "./FinanceReportsPeopleAndProjects.vue?vue&type=script&lang=js"
import style0 from "./FinanceReportsPeopleAndProjects.vue?vue&type=style&index=0&id=6464795b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464795b",
  null
  
)

export default component.exports